export default __webpack_public_path__ + "static/media/BO.72c29cd7.png";